// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessagePinTitle__container-d67433 {
  letter-spacing: var(--font-spacing-button);
  color: var(--brand-primary-40);
}

.MessagePinTitle__title-e58ea4 {
  font: var(--font-button);
}

.MessagePinTitle__counter-d624c7 {
  font: var(--font-subtitle-4);
  margin-inline-start: 5px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/MessagePin/MessagePinTitle/MessagePinTitle.styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,8BAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,4BAAA;EACA,wBAAA;AACF","sourcesContent":[".container {\n  letter-spacing: var(--font-spacing-button);\n  color: var(--brand-primary-40);\n}\n\n.title {\n  font: var(--font-button);\n}\n\n.counter {\n  font: var(--font-subtitle-4);\n  margin-inline-start: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessagePinTitle__container-d67433`,
	"title": `MessagePinTitle__title-e58ea4`,
	"counter": `MessagePinTitle__counter-d624c7`
};
module.exports = ___CSS_LOADER_EXPORT___;
